import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, finalize } from 'rxjs/operators';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LookupModel } from '../models/common/lookup.model';
import { SpinnerService } from '../shared-new/services/spinner.service';
import { NotificationTypeDto, UserNotificationType } from '../shared-new/enums/notification-type.enum';

@Injectable({
  providedIn: 'root',
})
export class LookupService {
  public baseUrl = environment.api2BaseUrl;
  public onError: BehaviorSubject<string> = new BehaviorSubject('');
  public serviceParameter = {
    'Content-Type': 'application/json; charset=utf-8',
    Accept: 'application/json',
    Authorization: '',
  };

  public constructor(private readonly http: HttpClient, private spinnerService: SpinnerService) { } // Inject SpinnerService

  public getHorseTypes(): Observable<LookupModel[]> {
    this.spinnerService.addRequest('getHorseTypes'); // Show spinner
    return this.http.get<LookupModel[]>(`${this.baseUrl}/api/lookups/horseTypes`, {
      withCredentials: false,
      observe: 'response',
    }).pipe(
      catchError((error: Error) => {
        this.onError.next(error.message);
        return throwError(error);
      }),
      map((res) => res.body),
      finalize(() => this.spinnerService.popRequest('getHorseTypes')) // Hide spinner on completion
    );
  }

  public getStudyFileMimeTypes(): Observable<LookupModel[]> {
    this.spinnerService.addRequest('getStudyFileMimeTypes'); // Show spinner
    return this.http.get<LookupModel[]>(`${this.baseUrl}/api/lookups/StudyFileMimeTypes`, {
      withCredentials: false,
      observe: 'response',
    }).pipe(
      catchError((error: Error) => {
        this.onError.next(error.message);
        return throwError(error);
      }),
      map((res) => res.body),
      finalize(() => this.spinnerService.popRequest('getStudyFileMimeTypes')) // Hide spinner on completion
    );
  }
  public getSaleStatuses(saleId:number): Observable<LookupModel[]> {
    this.spinnerService.addRequest('getSaleStatuses'); // Show spinner
    return this.http.get<LookupModel[]>(`${this.baseUrl}/api/lookups/${saleId}/SaleStatuses`, {
      withCredentials: false,
      observe: 'response',
    }).pipe(
      catchError((error: Error) => {
        this.onError.next(error.message);
        return throwError(error);
      }),
      map((res) => res.body),
      finalize(() => this.spinnerService.popRequest('getSaleStatuses')) // Hide spinner on completion
    );
  }

  public getStudySaleDocTypes(isReport:boolean): Observable<LookupModel[]> {
    this.spinnerService.addRequest('getStudySaleDocTypes'); // Show spinner
    return this.http.get<LookupModel[]>(`${this.baseUrl}/api/lookups/${isReport}/SaleDocTypes`, {
      withCredentials: false,
      observe: 'response',
    }).pipe(
      catchError((error: Error) => {
        this.onError.next(error.message);
        return throwError(error);
      }),
      map((res) => res.body),
      finalize(() => this.spinnerService.popRequest('getStudySaleDocTypes')) // Hide spinner on completion
    );
  }

  public getUserNotificationTypes(userId: number): Observable<UserNotificationType[]> {
    this.spinnerService.addRequest('getNotificationTypes'); // Show spinner
    return this.http.get<UserNotificationType[]>(`${this.baseUrl}/api/lookups/${userId}/notification-types`, {
      withCredentials: false,
      observe: 'response',
    }).pipe(
      catchError((error: Error) => {
        this.onError.next(error.message);
        return throwError(error);
      }),
      map((res) => res.body),
      finalize(() => this.spinnerService.popRequest('getNotificationTypes')) // Hide spinner on completion
    );
  }
}
